import { makeStyles } from "@mui/styles";

const TermsOfServiceReviewPageStyles = makeStyles((theme) => ({
  container: {
    margin: theme.paddings.xs
  }
}));

export default TermsOfServiceReviewPageStyles;
